export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70c032b81f5fe78ad53de4e0652afe68903da4bb97&name=pushAdClickData!'